import { escapeHTML } from '@lumapps/utils/string/escapeHTML';
import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

import type { FileElement } from '../../types';

export const FILE_ELEMENTS: HTMLSerializeOptions['elements'] = {
    file: (node: FileElement) => {
        const fileInfo = {
            src: node.src,
            name: node.name,
            resource: node.resource,
            createdAt: node.createdAt,
            mimeType: node.mimeType,
            editedAt: node.editedAt,
            status: node.status,
            thumbnailUrl: node.thumbnailUrl,
        };
        return `<div class="wrex-file" data-file-info="${escapeHTML(JSON.stringify(fileInfo))}"></div>`;
    },
};
